import { useQuery } from '@tanstack/react-query'

import { getUsers } from '@src/api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks/use-axios'

export const useFetchUsers = (organizationId: string) => {
  const { axiosInstance } = useAxios()
  return useQuery({
    enabled: !!organizationId,
    queryFn: () =>
      getUsers(axiosInstance, {
        organizationId,
      }),
    queryKey: [REACT_QUERY_CACHE_KEYS.GET_USERS],
  })
}
